module.exports = __webpack_public_path__ + "7f281199258d96e249a7fce4101006b9.ttf";